import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SieniService } from 'src/app/shared/services/sieni.service';

@Component({
  selector: 'app-modal-logout',
  templateUrl: './modal-logout.component.html',
  styleUrls: ['./modal-logout.component.scss']
})
export class ModalLogoutComponent implements OnInit {

    @Output() close = new EventEmitter<string>();
    @Output() dismiss = new EventEmitter<string>();

    constructor(
        public activeModal: NgbActiveModal,
        public translate: TranslateService,
        public _globalService: SieniService
    ) { }

    ngOnInit() {
        this.translate.use(this._globalService.user.language.code)
    }

    onClose(message: string) {
        localStorage.clear();
        sessionStorage.clear();
        this.close.emit(message);
        // console.log(message)
        this.activeModal.close();
    }

    onDismiss(message: string) {
        this.dismiss.emit(message);
        this.activeModal.dismiss();
    }

}
